import baseApi from "src/config/api/base"
import { Apply1Request, Apply1Response} from "./types/apply"
import { RefreshCaptcha1Request, RefreshCaptcha1Response } from "./types/refreshCaptcha"
import { BaseResponse } from "./types/common"
import { GetCaptcha1Response, GetCaptcha1Request } from "./types/captcha"
import { GetConfigListRequest, GetConfigListResponse } from "./types/configList"

const api = baseApi.injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    getTokenByTckn1: builder.mutation<BaseResponse, string>({
      query: (body) => ({
        url: "",
        method: "POST",
        body : {
          tckn: body,
          functionCode: "SPE0021",
          NextTransactionUrl: "Facebook/SocialMediaPortalCreateSession/GetTokenByTckn1",
          TokenSessionId: "ABCDEFABCDEFABCDEFABCDEFABCDEFABCDEF",
        },
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    getCaptcha: builder.mutation<GetCaptcha1Response, GetCaptcha1Request>({
      query: (body) => ({
        url: "",
        method: "POST",
        body : {
          tckn : body.tckn,
          TokenSessionId : body.TokenSessionId,
          functionCode: "SPE0021",
          NextTransactionUrl: "Facebook/BirebirBankacilikLead/GetCaptcha1",
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    refreshCaptcha: builder.mutation<RefreshCaptcha1Response, RefreshCaptcha1Request>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          tckn: body.tckn,
          functionCode: "SPE0021",
          NextTransactionUrl: "Facebook/BirebirBankacilikLead/RefreshCaptcha1",
          TokenSessionId: body.TokenSessionId
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    apply1: builder.mutation<Apply1Response, Apply1Request>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          tckn: body.tckn,
          adSoyad: body.adSoyad,
          captcha: body.captcha,
          telefon: body.telefon,
          kvkk: body.kvkk,
          etk: body.etk,
          cid: body.cid,
          NextTransactionUrl: "Facebook/BirebirBankacilikLead/Apply1",
          TokenSessionId: body.TokenSessionId
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    getConfigList: builder.mutation<GetConfigListResponse, GetConfigListRequest>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          functionCode: "SPE0021",
          cid: body.cid,
          NextTransactionUrl: "Facebook/SMPUConfig/GetConfigListWithFunctionCode1",
          TokenSessionId: "ABCDEFABCDEFABCDEFABCDEFABCDEFABCDEF",
        },
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
  })
})

export const { useGetTokenByTckn1Mutation, useGetCaptchaMutation, useRefreshCaptchaMutation, useApply1Mutation, useGetConfigListMutation } = api

export default api
